import { memo } from 'react';
import { useDispatch } from 'react-redux';
import { SubWindow, formatList } from './sub-window';
import { useDidMount } from '../../../../../../../hooks/life-cycle';
import { DialogActions } from '../../../../../../../redux/dialog/dialog.action';
import { MasterActions } from '../../../../../../../redux/master/master.action';
import { useAppSelector } from '../../../../../../../hooks/use-redux';

type Props = {
  open: boolean;
  callbackClose: () => void;
}

const master = 'employee';
const listName = 'employeeList';

export const EigyoTantou = memo((props: Props) => {
  const { open, callbackClose } = props;

  const dispatch = useDispatch();
  const list = useAppSelector((v) => v.master[listName]);

  useDidMount(() => dispatch(MasterActions.api[master].getList({})));

  return (
    <SubWindow
      open={open}
      title="営業担当"
      header={['メールアドレス', '名前']}
      lists={list.map((v) => ([
        v.mail_address || <span className="alert">※未設定</span>,
        v.name || <span className="alert">※未設定</span>,
      ]))}
      callbackClose={callbackClose}
    />
  );
});
